import _ from 'lodash';
import { SyntheticEvent, useState } from 'react';
import { useGetCategories } from './hooks';

export const CategoryNavigation = () => {
  const [active, setActive] = useState(0);
  const { data } = useGetCategories();

  const getCategories = data?.getCategories?.getCategories;
  const count = data?.getCategories?.count;

  const currentLength = _.size(getCategories);

  const onClick = (event: SyntheticEvent<HTMLDivElement>) => {
    setActive(Number(event.currentTarget.getAttribute('data-id')));
    document
      .querySelector(
        `article.case-row[data-id="${event.currentTarget.getAttribute(
          'data-id',
        )}"] .case-row-title-name`,
      )
      ?.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
  };

  return (
    currentLength === count && (
      <div className="home-category-navigation">
        {_.map(getCategories, getCategory => (
          <div
            onClick={onClick}
            key={getCategory?.id}
            data-id={getCategory?.id}
            className={`home-category-navigation-item ${
              active === getCategory?.id && 'active'
            } `}
            data-rar={getCategory?.color}
          >
            <span>{getCategory?.getName}</span>
          </div>
        ))}
      </div>
    )
  );
};
